import { useState } from "react";
import "./collapsed-box.css";

import { ReactComponent as IconChevronUp } from "../../assets/svg/chevron_up.svg";

export const CollapsedBox = ({ height = 773, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleToggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <div className="collapse-box">
      <div className="collapse-toggle">
        <div className="line" />
        <button
          className="collapse-toggle-btn"
          onClick={handleToggleCollapse}
        >
          {isCollapsed ? "Show More" : "Show Less"}{" "}
         {/*  <IconChevronUp
            stroke="#5d5f6a"
            strokeWidth={"2px"}
            width={"14px"}
            height={"14px"}
          /> */}
        </button>
        <div className="line" />
      </div>

      <div
        className="collapsible-section"
        style={{
          height: isCollapsed ? "0" : 'auto' /* `${height}px` */,
          minHeight: isCollapsed ? "0" : `${height}px`,
          overflow: isCollapsed ? "hidden" : "visible",
          marginTop: isCollapsed ? "0" : "32px",
        }}
      >
        {children}
      </div>
      {/* {!isCollapsed && <div className="collapsible-section">{children}</div>} */}
    </div>
  );
};
